import React from 'react';
import IdleTimer from 'react-idle-timer';
import Timer from 'react-compound-timer';
import { func } from 'prop-types';

class GlobalSessionHandler extends React.Component {
  constructor() {
    super();
    this.idleTimerRef = React.createRef();
    this.timerRef = React.createRef();

    this.state = {
      timeoutValue: 48 * 60 * 60 * 1000, // 48 hrs timeout
    };

    this.onAction = this.onAction.bind(this);
    this.callbackOnTimeout = this.callbackOnTimeout.bind(this);
  }

  onAction() {
    if (this.timerRef) {
      this.timerRef.reset();
    }
  }

  callbackOnTimeout() {
    if (this.idleTimerRef) {
      this.idleTimerRef.reset();
    }
    if (this.timerRef) {
      this.timerRef.reset();
      this.timerRef.start();
    }
    this.props.callbackOnTimeout();
  }

  render() {
    return (
      <React.Fragment>
        <Timer
          ref={(ref) => {
            this.timerRef = ref;
          }}
          initialTime={this.state.timeoutValue}
          direction="backward"
          checkpoints={[
            {
              time: 0,
              callback: () => {
                this.callbackOnTimeout();
              },
            },
          ]}
        />
        <IdleTimer
          ref={(ref) => {
            this.idleTimerRef = ref;
          }}
          element={document}
          onAction={this.onAction}
          debounce={250}
          timeout={this.state.timeoutValue}
        />
      </React.Fragment>
    );
  }
}

GlobalSessionHandler.propTypes = {
  callbackOnTimeout: func.isRequired,
};

export default GlobalSessionHandler;
